import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'

import { useModals } from '@/shared/lib/modal-manager'

export function EditAnchorStrategyNameTrigger({
	children,
	scope,
}: {
	children: React.ReactNode
	scope: {
		value: string
		onChange: (value: string) => void
	}
}) {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const handleEditAnchorStrategyName = () => {
		showModal('GENERIC_RENAME_MODAL', {
			title: t('anchoring_management.strategy.edit_name', {
				defaultValue: 'Edit anchor strategy name',
			}),
			...scope,
		})
	}

	return (
		<Slot.Root onClick={handleEditAnchorStrategyName}>{children}</Slot.Root>
	)
}
